import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ui as UiConstants } from '@/constants';
import debounce from 'lodash/debounce';

@Component({
    name: 'CmgNotificationBar',
})
export default class CmgNotificationBar extends Vue {
    private debouncedBannerClose = debounce(() => {
        this.onCloseBanner();
    }, this.timeoutMs);

    get state() {
        return this.$appStore.state.ui.notificationBanner;
    }

    get visible() {
        return this.state.visible;
    }

    get message() {
        return this.state.message || 'Welcome!';
    }

    get details() {
        return this.state.details || '';
    }

    get backgroundColor() {
        return this.state.backgroundColor || UiConstants.colors.brownLight;
    }

    get timeoutMs() {
        return this.state.timeoutMs || 3000;
    }

    get messageLabel(): string {
        return this.message + this.details;
    }

    @Watch('visible', { immediate: false, deep: true })
    onVisibleChanged(newVisible: boolean) {
        if (newVisible) {
            this.debouncedBannerClose();
        }
    }

    onCloseBanner() {
        this.$services.ui.setBannerState({ visible: false, message: this.messageLabel });
        this.$services.ui.focusBack();
    }
}
